<script setup lang="ts">
  import { useForwardProps } from 'radix-vue';
  import { computed } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<{ class?: HTMLAttributes['class'] }>();

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
  });

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <div v-bind="forwardedProps" :class="cn('flex flex-row justify-between', props.class)">
    <slot />
  </div>
</template>
